export default {
  TOGGLE_LOADING(state, toggle) {
    state.loading = toggle;
  },

  TOGGLE_LOADING_WITH_MESSAGE(state, { toggle, message }) {
    state.loading = toggle;
    state.loadingMessage = message;
  },

  SET_LOADING_MESSAGE(state, message) {
    state.loadingMessage = message;
  },

  SET_STATUS(state, { status, message, errorCode }) {
    state.status = status;
    state.message = message;
    state.errorCode = errorCode;
  },

};



// WEBPACK FOOTER //
// ./src/stores/Notification/mutations/index.js